export const getPanelGroupStyle = () => ({
  borderTop: '1px solid #B3B0AD !important',
  borderBottom: '1px solid #B3B0AD !important',
  marginTop: 20,
});

export const getPanelHeadingStyle = () => ({
  marginTop: 6,
  marginBottom: 11,
});

export const getPanelDescriptionStyle = () => ({
  marginLeft: 15,
  paddingLeft: 23,
  marginTop: 10,
  fontSize: 14,
  lineHeight: '20px',
  maxWidth: 950,
  fontWeight: 'normal',
});

export const getPanelTitleStyle = (components, { palette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  display: 'inline-flex',
  position: 'relative',
  '& .helpbutton': {
    padding: 0,
  },

  '& a': {
    marginLeft: 5,
    fontSize: 18,
    color: palette.accent,
    fontWeight: 'normal',
    textDecoration: 'none',
  },
  '& a:hover': {
    backgroundColor: palette.white,
  },
  '& a.collapsed:after': {
    fontFamily: iconFontFamily,
    fontSize: 18,
    lineHeight: '24px',
    color: palette.accent,
    transform: 'rotate(90deg)',
  },
  '& a:after': {
    fontFamily: iconFontFamily,
    fontSize: 18,
    lineHeight: '24px',
    color: palette.accent,
    transform: 'rotate(180deg)',
  },
});

export const getPanelFooterStyle = (components, { palette }) => ({
  backgroundColor: palette.white,
  margin: 0,
  paddingLeft: 0,
});
